import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import { StyleSheet } from '@root/core/src/utils/styles';
import { regular } from '@root/brand/src/assets/fonts/root-sans/emotion';

export function AgentsOperatingHours() {
  return (
    <div
      css={styles.operatingHours}
      data-testid={'agent-operating-hours'}
    >
      <div css={styles.subtext}> We’re available: <br /></div>
      <ul css={styles.unorderedList} >
        <li css={styles.subtext}>Monday–Friday, 8:30&nbsp;a.m.&#8288;&#8211;&#8288;8:30&nbsp;p.m.&nbsp;ET </li>
        <li css={styles.subtext}>Saturday, 8:30&nbsp;a.m.&#8288;&#8211;&#8288;5&nbsp;p.m.&nbsp;ET</li>
      </ul>

    </div>
  );
}

const styles = StyleSheet.create({
  operatingHours: {
    ...regular(),
    alignItems: 'left',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  unorderedList: {
    paddingLeft: 26,
    textAlign: 'left',
  },
  subtext: {
    ...regular(),
    fontSize: 14,
    margin: 0,
  },
});

AgentsOperatingHours.propTypes = {
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};
